import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["id"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        class: "accordion mb-2",
        id: _ctx.id
    }, [
        _renderSlot(_ctx.$slots, "default")
    ], 8, _hoisted_1));
}
